import { formatEventName } from './helpers/event-name-formatter';
import { PROVIDER_NAMES } from '~/composables/analytics/providers/constants';

export const AnalyticsEvents = {
  PREFERENCES_SAVED: 'preferences_saved',
  PREFERENCE_GENDER_SET: 'preference_gender_set',
  PREFERENCE_AGE_SET: 'preference_age_set',
  PREFERENCE_LOOKING_FOR_SET: 'preference_looking_for_set',
  USER_REGISTERED: 'user_registered',
  REGISTRATION_STARTED: 'registration_started',
  EVENT_ACCESS_INITIALIZED: 'event_access_initialized',
  COMPLETE_REGISTRATION: 'complete_registration',
  REGISTRATION_COMPLETED: 'registration_completed',
  BIRTH_INFO_OPENED: 'birth_info_opened',
  BIRTH_INFO_SAVED: 'birth_info_saved',
  PREFERENCES_OPENED: 'preferences_opened',
  MATCH_BUTTON_CLICKED: 'match_button_clicked',
  MATCH_GENERATED_SUCCESS: 'match_generated_success',
  MESSAGE_SENT: 'message_sent',
  CONVERSATION_OPENED: 'conversation_opened',
  VALIDATION_CODE_VALIDATED: 'validation_code_validated',
  VALIDATION_CODE_SENT: 'validation_code_sent',
  PASSWORD_CREATED: 'password_created',
  EVENT_HOME_ACCESSED: 'event_home_accessed',
  EVENT_LANDING_PAGE_ACCESSED: 'event_landing_page_accessed',
};

export const AnalyticsUserProperties = [
  'email',
  'name',
  'birth',
  'phone_number',
  'has_phone',
  'phone_notification',
  'event_id',
  'event_name',
  'matches_count',
  'birth_place_city',
  'birth_place_state',
  'birth_place_country',
  'gender_identity',
  'gender_looking_for',
  'age_range_looking_for',
];

export const AnalyticsEventParams = {
  [AnalyticsEvents.PREFERENCES_SAVED]: {
    min_age: null,
    max_age: null,
    gender: null,
    looking_for_count: null,
    event_id: null,
    event_name: null,
    gender_identity: null,
    gender_looking_for: null,
    age_range_looking_for: null,
  },
  [AnalyticsEvents.PREFERENCE_GENDER_SET]: {
    gender: null,
    gender_text: null,
  },
  [AnalyticsEvents.PREFERENCE_AGE_SET]: {
    min_age: null,
    max_age: null,
  },
  [AnalyticsEvents.PREFERENCE_LOOKING_FOR_SET]: {
    looking_for: null,
    looking_for_values: null,
    count: null,
  },
  [AnalyticsEvents.USER_REGISTERED]: {
    email: null,
    name: null,
    birth: null,
    phone_number: null,
    has_phone: null,
    phone_notification: null,
    event_id: null,
    event_name: null,
  },
  [AnalyticsEvents.REGISTRATION_STARTED]: {
    event_id: null,
    event_name: null,
  },
  [AnalyticsEvents.EVENT_ACCESS_INITIALIZED]: {
    event_name: null,
  },
  [AnalyticsEvents.COMPLETE_REGISTRATION]: {
    event_name: null,
  },
  [AnalyticsEvents.BIRTH_INFO_OPENED]: {
    event_id: null,
    event_name: null,
  },
  [AnalyticsEvents.BIRTH_INFO_SAVED]: {
    event_id: null,
    event_name: null,
    has_city: null,
    has_state: null,
    has_country: null,
    birth_date: null,
    age: null,
    birth_place_city: null,
    birth_place_state: null,
    birth_place_country: null,
  },
  [AnalyticsEvents.PREFERENCES_OPENED]: {
    event_id: null,
    event_name: null,
    source: null,
  },
  [AnalyticsEvents.MATCH_BUTTON_CLICKED]: {
    event_id: null,
    event_name: null,
  },
  [AnalyticsEvents.MATCH_GENERATED_SUCCESS]: {
    event_id: null,
    event_name: null,
    matches_count: null,
    active_matches_count: null,
    sleepings_count: null,
  },
  [AnalyticsEvents.MESSAGE_SENT]: {
    event_id: null,
    event_name: null,
  },
  [AnalyticsEvents.CONVERSATION_OPENED]: {
    event_id: null,
    event_name: null,
    connected_user_id: null,
  },
  [AnalyticsEvents.VALIDATION_CODE_VALIDATED]: {
    event_id: null,
    event_name: null,
    method: null, // SMS or EMAIL
  },
  [AnalyticsEvents.VALIDATION_CODE_SENT]: {
    event_id: null,
    event_name: null,
    method: null, // SMS or EMAIL
  },
  [AnalyticsEvents.PASSWORD_CREATED]: {
    event_id: null,
    event_name: null,
  },
  [AnalyticsEvents.EVENT_HOME_ACCESSED]: {
    event_name: null,
    event_id: null,
  },
  [AnalyticsEvents.EVENT_LANDING_PAGE_ACCESSED]: {
    event_name: null,
    event_id: null,
  },
};

export const EventProviderMap = {
  [AnalyticsEvents.EVENT_LANDING_PAGE_ACCESSED]: {
    providers: [PROVIDER_NAMES.META_PIXEL, PROVIDER_NAMES.POSTHOG],
    eventNames: {
      [PROVIDER_NAMES.META_PIXEL]: (env, props) =>
        formatEventName({
          baseEventName: 'AcessouPaginaDoEvento',
          env,
          props,
          provider: PROVIDER_NAMES.META_PIXEL,
        }),
      [PROVIDER_NAMES.POSTHOG]: AnalyticsEvents.EVENT_LANDING_PAGE_ACCESSED,
    },
  },
  [AnalyticsEvents.EVENT_ACCESS_INITIALIZED]: {
    providers: [PROVIDER_NAMES.META_PIXEL, PROVIDER_NAMES.POSTHOG],
    eventNames: {
      [PROVIDER_NAMES.POSTHOG]: AnalyticsEvents.EVENT_ACCESS_INITIALIZED,
    },
  },
  [AnalyticsEvents.REGISTRATION_STARTED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
    eventNames: {
      [PROVIDER_NAMES.POSTHOG]: AnalyticsEvents.REGISTRATION_STARTED,
    },
  },
  [AnalyticsEvents.USER_REGISTERED]: {
    providers: [PROVIDER_NAMES.POSTHOG, PROVIDER_NAMES.META_PIXEL],
    eventNames: {
      [PROVIDER_NAMES.META_PIXEL]: (env, props) =>
        formatEventName({
          baseEventName: 'CadastroIniciado',
          env,
          props,
          provider: PROVIDER_NAMES.META_PIXEL,
        }),
      [PROVIDER_NAMES.POSTHOG]: AnalyticsEvents.USER_REGISTERED,
    },
  },
  [AnalyticsEvents.COMPLETE_REGISTRATION]: {
    providers: [PROVIDER_NAMES.META_PIXEL, PROVIDER_NAMES.POSTHOG],
    eventNames: {
      [PROVIDER_NAMES.META_PIXEL]: (env, props) =>
        formatEventName({
          baseEventName: 'CadastroConcluido',
          env,
          props,
          provider: PROVIDER_NAMES.META_PIXEL,
        }),
      [PROVIDER_NAMES.POSTHOG]: AnalyticsEvents.COMPLETE_REGISTRATION,
    },
  },
  [AnalyticsEvents.EVENT_HOME_ACCESSED]: {
    providers: [PROVIDER_NAMES.META_PIXEL, PROVIDER_NAMES.POSTHOG],
    eventNames: {
      [PROVIDER_NAMES.META_PIXEL]: (env, props) =>
        formatEventName({
          baseEventName: 'AcessouPaginaBuscarConexão',
          env,
          props,
          provider: PROVIDER_NAMES.META_PIXEL,
        }),
      [PROVIDER_NAMES.POSTHOG]: AnalyticsEvents.EVENT_HOME_ACCESSED,
    },
  },
  [AnalyticsEvents.BIRTH_INFO_OPENED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.BIRTH_INFO_SAVED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.PREFERENCES_OPENED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.PREFERENCES_SAVED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.PREFERENCE_GENDER_SET]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.PREFERENCE_AGE_SET]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.PREFERENCE_LOOKING_FOR_SET]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.MATCH_BUTTON_CLICKED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.MATCH_GENERATED_SUCCESS]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.MESSAGE_SENT]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.CONVERSATION_OPENED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.VALIDATION_CODE_VALIDATED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.VALIDATION_CODE_SENT]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
  [AnalyticsEvents.PASSWORD_CREATED]: {
    providers: [PROVIDER_NAMES.POSTHOG],
  },
};
